module.exports = __webpack_public_path__ + "img/collection-engagementRingsUsa.12d194b.jpg";